import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { Loadable } from '../base/components/Lodable'

const VentasArticuloPuntoVentaApp = Loadable(
  lazy(() => import('./view/VentasArticuloPuntoVenta')),
)

/**
 * Mapa de rutas
 */
export const reporteRoutesMap = {
  masVendidos: {
    path: '/reporte/articulos-mas-vendidos',
    name: 'Articulos mas vendidos',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const reporteRoutes = [
  {
    path: reporteRoutesMap.masVendidos.path,
    element: <VentasArticuloPuntoVentaApp />,
    auth: authRoles.admin,
  },
]

export default reporteRoutes
